import { BllOrtak } from './bll/bll-ortak';
import { BLLMalKabul } from './bll/bll-nlsiparis';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Ortak } from './ortak';
import { Nl_MalKabul } from '../models/NL_MalKabul';
@Injectable()
export class SyncProvider {
eklenecek_siparis=[];
    constructor(public bllMalKabul:BLLMalKabul,
        public bllOrtak:BllOrtak){

    };
    siparisiSunucudanGetir(siparisno) {
        return new Promise((res, err) => {
    console.log("giden sip no",siparisno)
            this.siparisiSunucudanGetirSync(siparisno).then(a => {
                this.siparisiSunucudanGetirSyncResult(a).then(b => {
    
                }).catch(y => {
                    err(y);
                })
            }).catch(z => {
                err(z);
            });
        })
    
    }
      siparisiSunucudanGetirSync(siparisno) {
        console.log("giden2 sip no",siparisno)
        return new Promise((resolve, reject) => {
          var formdata=new FormData();
          formdata.append("siparisno", siparisno.toString());
          this.bllOrtak.islem(formdata,"MalKabulListeDetay", "", false).then((result) => {
    
            var sonuc = <any>result;
    
            if (sonuc.Sonuc != null) {
              if (sonuc.Sonuc == 1) {
                resolve(sonuc.SonucObject);
              }
              else {
                reject();
              }
            }
            else
              resolve(result);
          }, (error) => {
            reject(error);
          });
        });
      }
      siparisiSunucudanGetirSyncResult(result) {
        return new Promise((resolve, reject) => {
    
          var eklenecekLokalSiparis: Nl_MalKabul[] = result;
          var guncellenecekLokalSiparis: Nl_MalKabul[] = result;
          //Eklenecek kayıtlar
          for (let item of eklenecekLokalSiparis) {
            this.eklenecek_siparis.push(item.STOK_KODU);
          }
    
          this.bllMalKabul.bulkUpdate(guncellenecekLokalSiparis, "ID").then(a => {
            this.bllMalKabul.bulkInsert(eklenecekLokalSiparis).then(a => {
              resolve(a);
            });
          })
    
        }).then(a => {
          result(a);
        })
    
    
      }
    
}


// WEBPACK FOOTER //
// ./src/providers/syncProvider.ts